/** @jsx jsx */
import React, {
	useRef,
	useState,
	useEffect,
	useContext,
	useCallback,
} from 'react';
import { Link } from 'gatsby';
//import Img from 'gatsby-image';
import { GatsbyImage } from "gatsby-plugin-image"
import { Box, Flex, Button, Heading, Text, jsx, Alert } from 'theme-ui';
import { IoIosAdd, IoIosRemove } from 'react-icons/io';
import { CartContext } from '../../provider/cart-provider';
import { LocalCartContext } from '../../provider/local-cart-provider';
import useOnClickOutside from '../../hooks/useOutsideClick';
import styles from './product-card.style';
import { getSessionState } from '../../helper/session-storage';

type PropsType = {
	price: any;
	path: string;
	title: string;
	thumbnail: any;
	variants: any;
	shopifyId: string;
	availableForSale: boolean;
	tags: any;
	metafields: any;
	productType: string;
};

const ProductCardWithLink: React.FC<PropsType> = (product) => {
	const {
		path,
		title,
		price,
		prevPrice,
		variants,
		variants: [initialVariant],
		thumbnail,
		tags,
		metafields,
		productType,
	} = product;

	const {
		store: { client },
	} = useContext(CartContext);

	const { products, add, update } = useContext(LocalCartContext);
	const counterRef = useRef(null!);
	const [showCounter, setShowCounter] = useState(false);
	useOnClickOutside(counterRef, () => setShowCounter(false));

	const [variant, setVariant] = useState({ ...initialVariant });
	const productVariant = variant;
	
	const [productPrice, setProductPrice] = useState({ price, prevPrice });
	const { shopConfig } = useContext(
		LocalCartContext
	);	
	const getPrice = (weight: any, shopConfig: any, applyMcDisc = false, price = 0 ) => {
		console.log(`price: ${JSON.stringify(price)}`)
		shopConfig = getSessionState('shopConfig');
		let gold, silver;
		let makingChargePc = 0;
		let makingChargeDisc = 0;		
		if(metafields && metafields.length > 0) {
			metafields.map( field => {
				if(field.key === 'making_charge_pc') {
					makingChargePc = field.value
				}
			})
		}
		if(shopConfig?.config) {
			shopConfig.config.map( field => {
				switch (field.key) {
					case 'gold':
						gold = field.value;
						break;
					case 'silver':
						silver = field.value;
						break;
					case 'mc_discount':
						makingChargeDisc = field.value;
						break;						
					default:
						break;
				}
			})
			/*if(parseFloat(makingChargePc) > parseFloat(makingChargeDisc) && applyMcDisc) {
				makingChargePc = makingChargePc - makingChargeDisc
			}*/	
			if( applyMcDisc ) {
				makingChargePc = parseFloat(makingChargePc) * ( 1 - parseFloat(makingChargeDisc)/100 )
			}
			let rate = productType === 'gold_jewellery' ? gold : productType === 'silver_jewellery' ? silver : 0;
			/*let rate = 0
			if(productType === 'gold_jewellery') {
				rate = gold
			}
			else if (productType === 'silver_jewellery') {
				rate = silver			
			}
			console.log(`rate: ${rate}`)	*/		
			if(rate !== 0 ) {
				return Intl.NumberFormat(undefined, {
					currency: 'INR',
					minimumFractionDigits: 2,
					style: 'currency',
				}).format(parseFloat( weight * rate + weight * rate * makingChargePc/100 + (weight * rate + weight * rate * makingChargePc/100) * 0.03));			
			}
			else {
				return Intl.NumberFormat(undefined, {
					currency: 'INR',
					minimumFractionDigits: 2,
					style: 'currency',
				}).format(parseFloat(price && price.amount ? price.amount : 0.00));			
			}
		}
		return Intl.NumberFormat(undefined, {
			currency: 'INR',
			minimumFractionDigits: 2,
			style: 'currency',
		}).format(parseFloat(0));			
			
	}

			
	const productIndex = products.findIndex(
		(item) => item.variantId === productVariant.shopifyId
	);

	const cartProduct = productIndex > -1 ? products[productIndex] : false;
	const cartProductQuantity = cartProduct ? cartProduct.quantity : 0;
	const [quantity, setQuantity] = useState(0);
	const [available, setAvailable] = useState(productVariant.availableForSale);
	const checkAvailability = useCallback(
		(productId) => {
			client.product.fetch(productId).then((fetchedProduct) => {
				// this checks the currently selected variant for availability
				//console.log(`fetchedProduct: ${JSON.stringify(fetchedProduct)}`)
				const result = fetchedProduct.variants.filter(
					(variant) => variant.id === productVariant.shopifyId
				);
				if (result && result.length > 0) {
					setAvailable(result[0].available);
					setProductPrice({price: getPrice(result[0].weight, shopConfig, true, result[0].price), prevPrice: getPrice(result[0].weight, shopConfig, false, result[0].compareAtPrice)});
					productVariant.price = result[0].price
					//productVariant.priceV2 = result[0].priceV2
					//productVariant.compareAtPriceV2 = result[0].compareAtPriceV2
					//productVariant.availableForSale = result[0].availableForSale
					productVariant.compareAtPrice = result[0].compareAtPrice
					setVariant(productVariant)
				}
			});
		},
		[client.product, productVariant.shopifyId, variants]
	);

	useEffect(() => {
		setQuantity(cartProductQuantity);
	}, [cartProductQuantity]);

	useEffect(() => {
		checkAvailability(product.shopifyId);
	}, [productVariant, checkAvailability, product.shopifyId]);

	const handleQuantityChange = (quantity: number) => {
		if (tags) {
			tags.map((tag) => {
				if (tag.includes("maxq")) {
					let maxq = tag.substring(4)
					if (quantity > maxq) {
						quantity = quantity - 1;
						return false;
					}
				}
			})		
		}
		update(productVariant.shopifyId, quantity);
		if (quantity < 1) {
			setShowCounter(false);
		}
	};

	const handleAddToCart = () => {
		if (!available) {
			return false;
		}
		let maxq = 999
		if(tags) {
			tags.map((tag) => {
				if (tag.includes("maxq")) {
					maxq = tag.substring(4)
				}
			})		
		}
		
		setShowCounter(true);
		if (quantity < 1) {
			const item = {
				title,
				thumbnail,
				quantity: 1,
				price: productVariant.price,
				currency: 'INR',
				variantId: productVariant.shopifyId,
				maxQuantity: maxq,
			};
			add(item);
		}
	};
	
	const handleSendToWa = () => {		
		if (typeof window !== "undefined") {
			let msg = encodeURIComponent(`I'm interested in - ${title} - https://${window.location.hostname}${path}`)
			typeof window !== "undefined" && window.gtag("event", "click", { productPath: path })
			window.open(`https://wa.me/919433828242?text=${msg}`)		
		}
	};	

	const addClass = ['productCard'];
	if (!available) {
		addClass.push('disabled');
	}

	return (
		<Box sx={styles.wrapper} className={addClass.join(' ')}>
			<Box className="image" sx={styles.imageWrapper}>
				
				{thumbnail && (
					<Link to={path}>
						<GatsbyImage image={thumbnail} alt={title}/> {' '}
					</Link>
				)}				
				<Box
					className={quantity > 0 && showCounter ? 'isActive' : ''}
					sx={styles.cart}
				>
					<Button
						variant="greenBadge"
						sx={styles.cartBtn}
						className={quantity > 0 ? 'active' : ''}
						title="Whatsapp us"
						onClick={() => handleSendToWa()}
					>
						{quantity > 0 ? (
							quantity
						) : (
							<svg fill="#ffffff" height="18px" width="18px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 308 308" stroke="#12f202"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="XMLID_468_"> <path id="XMLID_469_" d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156 c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687 c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887 c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153 c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348 c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802 c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922 c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0 c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458 C233.168,179.508,230.845,178.393,227.904,176.981z"></path> <path id="XMLID_470_" d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716 c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396 c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188 l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677 c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867 C276.546,215.678,222.799,268.994,156.734,268.994z"></path> </g> </g></svg>
						)}
					</Button>

					{quantity ? (
						<Box ref={counterRef} sx={styles.cartCounter}>
							<Button
								title="Decrement"
								onClick={() => handleQuantityChange(quantity - 1)}
							>
								<IoIosRemove />
							</Button>
							<Box>{quantity}</Box>
							<Button
								title="Increment"
								onClick={() => handleQuantityChange(quantity + 1)}
							>
								<IoIosAdd />
							</Button>
						</Box>
					) : null}
				</Box>
			</Box>

			<Link to={path}>
				<Box className="content">
					<Flex sx={styles.meta}>
						<Text as="span" sx={styles.price}>
							{productPrice.price}
						</Text>						
						{!available && (
							<Box as="span" sx={styles.soldOut}>
								Sold Out
							</Box>
						)}
					</Flex>
					<Flex sx={styles.meta}>
						<Text as="span" sx={styles.prevPrice}>
							{productPrice.prevPrice}
						</Text>							
					</Flex>					
					<Heading as="h4" sx={styles.title}>
						{title}
					</Heading>
				</Box>
			</Link>
		</Box>
	);
};

export default ProductCardWithLink;
